import { useQuery } from '@tanstack/react-query';
import { analyticsService } from '../../../services/analyticsService';
import type { ConversationAnalyticsData } from '../../../types';
import { useSessionGate } from '../../../hooks/useSessionGate';

export interface ExtendedAnalyticsSummary {
  this_month_sessions?: number;
  sessions_mom_pct?: number | null;
  answer_rate?: number | null;
  answer_rate_mom_pct?: number | null;
  unanswered_count?: number;
  visitors_count?: number;
  chat_users_count?: number;
  messages_count?: number;
}

const getDefaultDateRange = () => {
  const to = new Date();
  const from = new Date();
  from.setDate(from.getDate() - 30);
  const fmt = (d: Date) =>
    `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  return { fromDate: fmt(from), toDate: fmt(to) };
};

export const useConversationAnalytics = (
  domainId: string,
  fromDate?: string,
  toDate?: string,
) => {
  const defaults = getDefaultDateRange();
  const resolvedFrom = fromDate || defaults.fromDate;
  const resolvedTo = toDate || defaults.toDate;

  const { expired } = useSessionGate();
  return useQuery<{ success: boolean; data: ConversationAnalyticsData }>({
    queryKey: ['conversationAnalytics', domainId, resolvedFrom, resolvedTo],
    queryFn: () => analyticsService.getConversationAnalytics(domainId, resolvedFrom, resolvedTo),
    enabled: !!domainId && !expired,
  });
};
